import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  addNotification,
  closeNotification,
  resetNotificationPayload,
  Notification,
} from "../../ducks/notifications/notifications";

type NotificationOptions = {
  closeIdsOnAppear?: string[];
  resetPayload?: boolean;
  skip?: boolean;
};

export const useNotification = <Trigger>(
  trigger: Trigger,
  payload: Notification,
  options: NotificationOptions = {},
) => {
  const dispatch = useDispatch();
  const { skip, closeIdsOnAppear, resetPayload } = options;

  useEffect(() => {
    if (!skip) {
      closeIdsOnAppear && closeIdsOnAppear.map(id => dispatch(closeNotification(id)));
      trigger && dispatch(addNotification(payload));
      resetPayload && dispatch(resetNotificationPayload());
    }
  }, [trigger]);
};
